import { takeLatest, put, call, select, delay } from 'redux-saga/effects';
import { message } from 'antd';
import { autoRequest } from '@api/createRequestStore';
import { verifyConfiguration, saveConfiguration } from '@api/serviceIntegrations';
import { SERVICE_INTEGRATION_MODE_MAIN } from '@utils/constants';
import { fetchData } from '../existingIntegrations/actions';
import * as actions from './actions';
import * as types from './types';
import { verifyConfigPayloadSelector, saveConfigPayloadSelector } from './selectors';
import { setMode } from '../base/actions';

function* verifyConfig() {
  const payload = yield select(verifyConfigPayloadSelector);
  try {
    yield autoRequest(verifyConfiguration, types.SCOPE, payload);
    yield put(actions.toggleVerifyDialog());
  } catch (error) {
    message.error(error.message || 'Unknown error!');
  }
}

function* saveConfig() {
  const payload = yield select(saveConfigPayloadSelector);
  // if configId is present, it means it's an edit config request
  if (!payload.configId) {
    delete payload.configId;
  }

  try {
    yield autoRequest(saveConfiguration, types.SCOPE, payload);
    yield put(fetchData());
    yield call(message.success, 'Service Configuration has been saved');
    yield delay(1000);
    yield put(actions.clearConfig());
    yield put(setMode(SERVICE_INTEGRATION_MODE_MAIN));
  } catch (error) {
    message.error(error.message || 'Unknown error!');
  }
}

function* watchVerifyConfig() {
  yield takeLatest([types.VERIFY_CONFIG], verifyConfig);
}

function* watchSaveConfig() {
  yield takeLatest([types.SAVE_CONFIG], saveConfig);
}

export default [watchVerifyConfig, watchSaveConfig];
